export const zindex_lowest_backdrop = 5; //the z-index of the lowest backdrop layer if many level
export const zindex_lowest_modal_level = 6;
export const zindex_fab = 10; //should be heigher than : header / navbars / backdrop (modal : take care)
export const zindex_side_sheet_backdrop = 100; //overlay under the side sheet
export const zindex_side_sheet = 100;
export const zindex_drop = 110;
